/* eslint-disable import/prefer-default-export, prefer-destructuring */

import axios from 'axios';

export const handleChangeAddress = async (value) => {
  if (!value || value.trim() === '') {
    throw new Error('Please enter correct and complete address.');
  }

  try {
    const address = {
      userplace_id: null,
      addressLine1: '',
      city: '',
      state: '',
      zipcode: '',
      latitude: 0,
      longitude: 0,
      location_type: 2,
    };

    const query = `https://maps.googleapis.com/maps/api/geocode/json?address=${value}&key=${
      process.env.REACT_APP_GOOGLEAPIKEY
    }`.replace('#', '');
    const resp = await axios.get(encodeURI(query));

    let addressLine1 = '';
    let latitude = 0;
    let longitude = 0;
    let zipcode = '';
    let city = '';
    let state = '';

    if (resp.data.results.length) {
      let firstValidResult = resp.data.results.find(
        (res) =>
          res.address_components.some((ac) => ac.types.includes('street_number')) &&
          res.address_components.some((ac) => ac.types.includes('route'))
      );

      if (!firstValidResult) {
        firstValidResult = resp.data.results[0];
      }

      if (firstValidResult) {
        const { lat, lng } = firstValidResult.geometry.location;
        latitude = lat;
        longitude = lng;

        let streetNumber = '';
        let routeName = '';

        firstValidResult.address_components.forEach((element) => {
          const types = element.types || [];

          if (types.includes('street_number')) {
            streetNumber = element.long_name;
          }
          if (types.includes('route')) {
            routeName = element.long_name;
          }
          if (types.includes('postal_code')) {
            zipcode = element.short_name;
          }
          if (
            types.includes('political') &&
            (types.includes('locality') || types.includes('sublocality') || types.includes('neighborhood'))
          ) {
            city = element.long_name;
          }
          if (types.includes('administrative_area_level_1') && types.includes('political')) {
            state = element.short_name;
          }
        });

        // Build the address line safely
        addressLine1 = `${streetNumber} ${routeName}`.trim();

        // Patch for Los Angeles: prefer neighborhood if available
        if (city && city.toLowerCase() === 'los angeles') {
          const neighborhood = firstValidResult.address_components.find((el) => el.types.includes('neighborhood'));
          if (neighborhood?.long_name) {
            city = neighborhood.long_name;
          }
        }

        if (!addressLine1) {
          throw new Error('Please enter correct and complete address.');
        }

        address.addressLine1 = addressLine1;
        address.zipcode = zipcode;
        address.city = city;
        address.state = state;
        address.latitude = latitude;
        address.longitude = longitude;

        return address;
      }
    }

    throw new Error('Please enter correct address.');
  } catch (e) {
    throw new Error(e);
  }
};

export const contractAddressAndLabel = (addressObject) => {
  return {
    locationType: addressObject.location_type,
    label: addressObject.label,
    addressValue: `${addressObject.addressLine1 ? `${addressObject.addressLine1}, ` : ''}${
      addressObject.city ? `${addressObject.city}, ` : ''
    } ${addressObject.state || ''} ${addressObject.zipcode || ''}`,
  };
};

export const constractAddressName = (addressObject) => {
  return `${addressObject.label ? `${addressObject.label}, ` : ''}${
    addressObject.addressLine1 ? `${addressObject.addressLine1}, ` : ''
  }${addressObject.city ? `${addressObject.city}, ` : ''} ${addressObject.state || ''} ${addressObject.zipcode || ''}`;
};
